import { createSlice }    from '@reduxjs/toolkit';
import * as eventReducers from 'Redux/Reducers/Event';
import { Event }          from 'Domain/Models';

export interface IEventState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: Record<string, Event>,
  lastUpdateId: string | null,
  maxCount: number,
  assignedEmployeeIds: string[],
}

export const eventSlice = createSlice({
  name: 'event',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {},
    maxCount: 0,
    lastUpdateId: null,
    updatedAt: 0,
    assignedEmployeeIds: [],
  },
  reducers: eventReducers,
});
